export default {
    yes: "Oui",
    no: "Non"
}